import { DefaultNotification } from "./DefaultNotification";
import * as config from "../../constants/config";
import {NotificationTypes} from "../../constants/NotificationTypes";

export class DefaultError extends DefaultNotification {
    constructor(notificationAdapter) {
	    const message = "There was an error while attempting to contact the server. If the problem persists, contact " + config.supportEmail + ".";
	    super(notificationAdapter, NotificationTypes.ERROR, message);
    }
}